const SECTION_IDS = ["campaign", "bidding", "products", "automaticBids", "negatives"] as const;
export type SectionId = (typeof SECTION_IDS)[number];

export interface SubmitRecoveryTarget {
  step: 1 | 2;
  section: Extract<SectionId, "campaign" | "products">;
}

/** Maps a failed submit to the wizard position where the user can fix it. */
export function recoveryTargetForSubmitError(code: string | null): SubmitRecoveryTarget | null {
  if (
    code === "campaign_creation.authorization_invalid" ||
    code === "campaign_creation.account_capability_unavailable"
  )
    return { step: 1, section: "campaign" };
  if (code === "campaign_creation.capability_unsupported") return { step: 2, section: "campaign" };
  if (
    code === "catalog.refresh_required" ||
    code === "campaign_creation.product_selection_invalid" ||
    code === "campaign_creation.product_limit_exceeded"
  )
    return { step: 2, section: "products" };
  return null;
}

export function sectionForPath(path: string): SectionId {
  if (path.startsWith("products")) return "products";
  if (path.startsWith("defaultBid") || path.startsWith("groupBids")) return "automaticBids";
  if (path.startsWith("negative")) return "negatives";
  if (path.startsWith("placement")) return "bidding";
  return "campaign";
}
